<div class="loader-container">
  <div class="loader-bar">
    <div class="loader-progress" [style.width.%]="progress"></div>
  </div>
  <div class="loader-message">{{ message }}</div>
</div>